import {useCallback} from 'react';
import {
    EventAction,
    EventCategory,
    EventCurrencyCodes,
    EventLabel,
    EventNames,
} from 'modules/google-analytics/constants';
import {IProductShort} from 'modules/products/types';
import {useGtagEventLocation} from 'hooks/analytics/gtag/helpers/useGtagEventLocation';
import {IAnalyticsMeta} from 'core/types';
import {getProductBrand} from 'modules/product-card/helpers';
import {checkIsGFEvent, sendGtagEvent} from 'hooks/analytics/gtag/helpers';

// prod add
// {
//     event: 'OWOX',
//     eventCategory: 'Interactions',
//     eventAction: 'add',
//     eventContent: '',
//     eventLocation: 'CATALOG_PAGE',
//     eventProductName: 'Dos Caprichos Crianza',
//     eventProductId: 290097,
//     eventProductPrice: '1890.00',
//     eventLabel: 'wishlist',
// };

// prod remove json
// {
//     event: 'OWOX',
//     eventCategory: 'Interactions',
//     eventAction: 'remove',
//     eventContent: '',
//     eventLocation: 'CATALOG_PAGE',
//     eventProductName: 'Dos Caprichos Crianza',
//     eventProductId: 290097,
//     eventProductPrice: '1890.00',
//     eventLabel: 'wishlist',
// }

export const useProductWishlistGtag = () => {
    const {eventLocation} = useGtagEventLocation();

    return useCallback(
        // eslint-disable-next-line @typescript-eslint/naming-convention,complexity
        (
            product: Partial<IProductShort>,
            analytics: IAnalyticsMeta = {positionIndex: 1},
            eventAction = EventAction.Add,
        ) => {
            const isGF = checkIsGFEvent(analytics);

            const brand = getProductBrand(product as any);

            // eslint-disable-next-line no-nested-ternary
            const eventLabel = !isGF
                ? EventLabel.Wishlist
                : eventAction === EventAction.Add
                  ? EventLabel.Wishlist
                  : `product | ${EventLabel.Wishlist} | ${EventAction.Remove}`;

            const dataLayerList = {
                event: EventNames.OWOX,
                eventCategory: EventCategory.Interactions,
                // eslint-disable-next-line no-nested-ternary
                eventAction: !isGF
                    ? eventAction === EventAction.Add
                        ? EventAction.Add
                        : EventAction.Remove
                    : eventAction === EventAction.Add
                      ? EventAction.Add
                      : EventAction.Click,
                eventLabel,
                eventLocation,
                eventContext: !isGF
                    ? (analytics.listName ?? eventLocation ?? undefined)
                    : `${analytics.listName ?? eventLocation ?? ''} | ${product.id}`,
                ...(!isGF && {
                    ecommerce: {
                        currencyCode: EventCurrencyCodes.RUB,
                        click: {
                            list: analytics.listName ?? eventLocation ?? undefined,
                            products: [
                                {
                                    id: product.id,
                                    name: product.name,
                                    category: product.sections?.[0].title,
                                    price: product.price?.discount.price,
                                    brand,
                                    position: analytics.positionIndex || 1,
                                    list: analytics.listName ?? eventLocation ?? undefined,
                                },
                            ],
                        },
                    },
                }),
            };
            sendGtagEvent(dataLayerList);
        },
        [eventLocation],
    );
};
